var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardBlue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43507 0C1.09022 0 0 1.11929 0 2.5V4.16667H17.8571V2.5C17.8571 1.11929 16.7669 0 15.4221 0H2.43507ZM17.8571 5.83333H0V12.5C0 13.8807 1.09022 15 2.43506 15H15.4221C16.7669 15 17.8571 13.8807 17.8571 12.5V5.83333ZM5.68182 10.4167C5.68182 11.107 5.13671 11.6667 4.46429 11.6667C3.79186 11.6667 3.24675 11.107 3.24675 10.4167C3.24675 9.72631 3.79186 9.16667 4.46429 9.16667C5.13671 9.16667 5.68182 9.72631 5.68182 10.4167ZM8.52273 11.6667C9.19515 11.6667 9.74026 11.107 9.74026 10.4167C9.74026 9.72631 9.19515 9.16667 8.52273 9.16667C7.8503 9.16667 7.3052 9.72631 7.3052 10.4167C7.3052 11.107 7.8503 11.6667 8.52273 11.6667Z",
    fill: "url(#paint0_radial_10584_13042)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43507 0C1.09022 0 0 1.11929 0 2.5V4.16667H17.8571V2.5C17.8571 1.11929 16.7669 0 15.4221 0H2.43507ZM17.8571 5.83333H0V12.5C0 13.8807 1.09022 15 2.43506 15H15.4221C16.7669 15 17.8571 13.8807 17.8571 12.5V5.83333ZM5.68182 10.4167C5.68182 11.107 5.13671 11.6667 4.46429 11.6667C3.79186 11.6667 3.24675 11.107 3.24675 10.4167C3.24675 9.72631 3.79186 9.16667 4.46429 9.16667C5.13671 9.16667 5.68182 9.72631 5.68182 10.4167ZM8.52273 11.6667C9.19515 11.6667 9.74026 11.107 9.74026 10.4167C9.74026 9.72631 9.19515 9.16667 8.52273 9.16667C7.8503 9.16667 7.3052 9.72631 7.3052 10.4167C7.3052 11.107 7.8503 11.6667 8.52273 11.6667Z",
    fill: "black",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10584_13042",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.92857 7.5) rotate(90) scale(7.5 8.92857)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5573FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4441E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBlue2);
export default __webpack_public_path__ + "static/media/credit-card-blue2.be799e73b00b97e804c5a5f11b7c56cf.svg";
export { ForwardRef as ReactComponent };